"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStateSlug = void 0;

require("core-js/modules/es.array.find.js");

require("core-js/modules/es.function.name.js");

var _states = require("../constants/states");

/**
 * Get the state slug for the specified state name or code
 */
var getStateSlug = function getStateSlug(nameOrCode) {
  if (!nameOrCode) {
    return null;
  }

  if (nameOrCode === 'District of Columbia') {
    return 'washington-dc';
  }

  var state = _states.US_STATES_AND_TERRITORIES.find(function (s) {
    return s.name.toLowerCase() === nameOrCode.toLowerCase() || s.stateCode.toLowerCase() === nameOrCode.toLowerCase();
  });

  return (state === null || state === void 0 ? void 0 : state.slug) || null;
};

exports.getStateSlug = getStateSlug;